import React, { Fragment, isValidElement } from 'react';

function findChildPosition(
    children: React.ReactNode | undefined,
    displayName?: string,
): number | undefined {
    const childrenArray = children ? React.Children.toArray(children) : [];
    let result;

    if (children && displayName) {
        for (let i = 0; i < childrenArray.length; i++) {
            const child = childrenArray[i];

            if (!isValidElement(child)) {
                continue;
            }

            const { type } = child;

            if (type === (<Fragment />).type && child.props.children) {
                const deepChild = findChildPosition(
                    child.props.children,
                    displayName,
                );

                if (deepChild) {
                    result = deepChild;
                    break;
                }
            }

            if (typeof type === 'string') {
                continue;
            }

            // TypeScript will complaing about the lack of `displayName` prop unless
            // we do a type cast.
            if (
                (type as { displayName?: string })?.displayName?.includes(
                    displayName,
                )
            ) {
                result = i;
                break;
            }
        }
    }

    return result;
}

export default findChildPosition;
